module.exports = __webpack_public_path__ + "img/10-6.9ae06098.png";